export default {
    props: {
        adaptiveSlotHeight : {
            type: Boolean,
            default: undefined,
            kComposite: 'adaptiveSlotHeight'
        }, 
        allDayEventTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'allDayEventTemplate'
        }, 
        allDaySlot: {
            type: Boolean,
            default: undefined,
            kComposite: 'allDaySlot'
        }, 
        allDaySlotTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'allDaySlotTemplate'
        }, 
        columnWidth: {
            type: Number,
            default: undefined,
            kComposite: 'columnWidth'
        }, 
        dateHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'dateHeaderTemplate'
        }, 
        dayTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'dayTemplate'
        }, 
        editable: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable'
        }, 
        editableCreate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.create'
        }, 
        editableDestroy: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.destroy'
        }, 
        editableUpdate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.update'
        }, 
        endTime: {
            type: Date,
            default: undefined,
            kComposite: 'endTime'
        }, 
        eventHeight: {
            type: [String, Number],
            default: undefined,
            kComposite: 'eventHeight'
        }, 
        eventSpacing : {
            type: Number,
            default: undefined,
            kComposite: 'eventSpacing'
        }, 
        eventsPerDay : {
            type: Number,
            default: undefined,
            kComposite: 'eventsPerDay'
        }, 
        eventTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'eventTemplate'
        }, 
        eventTimeTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'eventTimeTemplate'
        }, 
        groupDate: {
            type: Boolean,
            default: undefined,
            kComposite: 'group.date'
        }, 
        groupOrientation: {
            type: String,
            default: undefined,
            kComposite: 'group.orientation'
        }, 
        majorTick: {
            type: Number,
            default: undefined,
            kComposite: 'majorTick'
        }, 
        majorTimeHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'majorTimeHeaderTemplate'
        }, 
        minorTickCount: {
            type: Number,
            default: undefined,
            kComposite: 'minorTickCount'
        }, 
        minorTimeHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'minorTimeHeaderTemplate'
        }, 
        selected: {
            type: Boolean,
            default: undefined,
            kComposite: 'selected'
        }, 
        selectedDateFormat: {
            type: String,
            default: undefined,
            kComposite: 'selectedDateFormat'
        }, 
        selectedShortDateFormat: {
            type: String,
            default: undefined,
            kComposite: 'selectedShortDateFormat'
        }, 
        showWorkHours: {
            type: Boolean,
            default: undefined,
            kComposite: 'showWorkHours'
        }, 
        slotTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'slotTemplate'
        }, 
        startTime: {
            type: Date,
            default: undefined,
            kComposite: 'startTime'
        }, 
        title: {
            type: String,
            default: undefined,
            kComposite: 'title'
        }, 
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        },
        virtual: {
            type: Boolean,
            default: undefined,
            kComposite: 'virtual'
        }, 
        workWeekStart: {
            type: Number,
            default: undefined,
            kComposite: 'workWeekStart'
        }, 
        workWeekEnd: {
            type: Number,
            default: undefined,
            kComposite: 'workWeekEnd'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/KendoSchedulerView/Views.js